import { useMemo } from 'react';
import APP_CONFIG from '../../../config';
import styled from 'styled-components';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import AssignEmailControllers from './AssignEmailControllers';

const StyledDropdown = styled(Dropdown)`
  width: 173px;
  z-index: 1000;
`;

const Label = styled.span`
  color: var(--light-primary-text-color, #323338);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const DropdownControllers = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
  queryData,
}) => {
  const statusOptions = useMemo(() => {
    const preSeletedColumns = [];

    addedFormFields
      ?.filter(
        (field) =>
          field.itemId === APP_CONFIG.form_fields.dropdown.id &&
          field.id !== selectedItem?.id,
      )
      ?.forEach((val) => {
        if (val?.column?.value) {
          preSeletedColumns.push(val.column.value);
        }
      });

    const options = queryData?.data?.items[0]?.column_values
      ?.filter(
        (column) =>
          column.type === APP_CONFIG.monday_constants.column_types.status &&
          !preSeletedColumns.includes(column.id),
      )
      ?.map((x) => {
        return { value: x.id, label: x.title };
      });
    return options;
  }, []);

  function handleCheckboxChange(e) {
    const isChecked = e.target.checked;
    selectedItem.required = isChecked;
    updateFormFields([...addedFormFields]);
  }

  function handleSaveInOptionsChange(value) {
    if (value?.onClick) {
      return value.onClick();
    }

    selectedItem.column = value;
    updateFormFields([...addedFormFields]);
  }

  return (
    <>
      <Label>{t('Show options from')}</Label>
      <StyledDropdown
        clearable={false}
        options={statusOptions}
        size={Dropdown.size.SMALL}
        value={selectedItem.column}
        placeholder={`-- ${t('Select Status')} --`}
        className="dropdown-stories-styles_with-chips"
        onChange={handleSaveInOptionsChange}
      />
      <Checkbox
        label={t('Required')}
        checked={selectedItem?.required}
        onChange={handleCheckboxChange}
      />
      <AssignEmailControllers
        t={t}
        hideTipseen
        selectedItem={selectedItem}
        addedFormFields={addedFormFields}
        updateFormFields={updateFormFields}
      />
    </>
  );
};

export default DropdownControllers;
